// extracted by mini-css-extract-plugin
export var animationContainer = "_o7-0";
export var footer = "_o7-1";
export var gray = "_o7-2";
export var lineItem = "_o7-3";
export var lineItemImage = "_o7-4";
export var lineItemInfo = "_o7-5";
export var lineItemText = "_o7-6";
export var lineItems = "_o7-7";
export var modalContent = "_o7-8";
export var options = "_o7-9";
export var orderName = "_o7-a";
export var refundAmount = "_o7-b";